<div *ngIf="!authService?.isAutoLoginProcessing" class="login-main-container">
  <div class="login-side-logo" *ngIf="!isTabView">
    <img
      appPrependUrl
      src="/assets/images/transparent-home-login.png"
      alt="MyGooru Logo"
      class="logo"
    />
  </div>
  <div class="login-container">
      <!-- <div class="logo-container">
        <img
          appPrependUrl
          src="/assets/images/gooru-chat-logo.svg"
          alt="MyGooru Logo"
          class="logo"
        />
        <h2 class="logo-header">A GPS for Learning</h2>
      </div> -->

    <div class="illustration-container">
      <img
        appPrependUrl
        src="/assets/images/myg-mobile-profile.svg"
        alt="Learning Illustration"
      />
    </div>
    <div class="login-input-container" *ngIf="!otpverification; else verify">
      <p class="input-header" *ngIf="timezone === 'Asia/Calcutta'">
        Enter your email, phone, or username
      </p>
      <p class="input-header" *ngIf="timezone !== 'Asia/Calcutta'">
        Enter Your Email
      </p>

      <div class="input-container" [class.focused]="isFocused">
        <div class="input-wrapper">
          <!-- Phone Input for Indian Users (Timezone Check) -->
          <div *ngIf="isPhoneInput && timezone === 'Asia/Calcutta'">
            <!-- You can create a country selector component if needed -->
            <lib-country-list
              *ngIf="isPhoneInput && timezone === 'Asia/Calcutta'"
              [selectedCountryConfig]="selectedCountryConfig"
              [countryListConfig]="countryListConfig"
              (onCountryChange)="onCountryChange($event)"
              [selectedCountryCode]="lastSelectedCountryCode"
            >
            </lib-country-list>
          </div>

          <!-- Main Input Field -->
          <input
            #mainInput
            type="text"
            (focus)="isFocused = true" (blur)="isFocused = false" 
            [placeholder]="
              isPhoneInput || timezone === 'Asia/Calcutta'
                ? 'Enter your email, phone, or username'
                : 'Enter your Email'
            "
            [(ngModel)]="userInput"
            (ngModelChange)="onUserInputChange()"
            (keydown.enter)="sendOtp()"
            aria-label="Enter your email, phone, or username"
          />
        </div>
      </div>

      <!-- Validation Error Message -->
      <div class="validation-error" *ngIf="validationError">
        {{ validationError }}
      </div>

      <!-- Submit Button -->
      <button
        class="otp-button"
        (click)="sendOtp()"
        [disabled]="isLoading"
        [attr.aria-busy]="isLoading ? 'true' : 'false'"
      >
        <ng-container *ngIf="!isLoading; else loading">
          Submit
        </ng-container>
        <ng-template #loading>
          <span class="loader"></span> Loading...
        </ng-template>
      </button>
    </div>

    <ng-template #verify>
      <div class="otp-container">
        <p class="input-header">Enter verification code</p>

        <!-- OTP Input Fields -->
        <div class="otp-input-group">
          <input
            type="text"
            maxlength="1"
            class="otp-digit"
            [(ngModel)]="otpDigits[0]"
            (input)="onOtpDigitInput($event, 0)"
            (paste)="handlePaste($event)"
            (keydown)="onKeyDown($event, 0)"
            inputmode="numeric"
            pattern="[0-9]*"
            id="otpInput0"
          />
          <input
            type="text"
            maxlength="1"
            class="otp-digit"
            [(ngModel)]="otpDigits[1]"
            (input)="onOtpDigitInput($event, 1)"
            (paste)="handlePaste($event)"
            (keydown)="onKeyDown($event, 1)"
            inputmode="numeric"
            pattern="[0-9]*"
            id="otpInput1"
          />
          <input
            type="text"
            maxlength="1"
            class="otp-digit"
            [(ngModel)]="otpDigits[2]"
            (input)="onOtpDigitInput($event, 2)"
            (paste)="handlePaste($event)"
            (keydown)="onKeyDown($event, 2)"
            inputmode="numeric"
            pattern="[0-9]*"
            id="otpInput2"
          />
          <input
            type="text"
            maxlength="1"
            class="otp-digit"
            [(ngModel)]="otpDigits[3]"
            (input)="onOtpDigitInput($event, 3)"
            (paste)="handlePaste($event)"
            (keydown)="onKeyDown($event, 3)"
            inputmode="numeric"
            pattern="[0-9]*"
            id="otpInput3"
            (keydown.enter)="verifyOTP()"
          />
        </div>

        <div class="otp-cont">
          <div class="otp-info">
            <div class="otp-text">
              <span class="otp-label">verification code sent to</span>
              <span class="otp-value">
                <ng-container *ngIf="userContext?.contactType === 'phone'">
                  {{ countryDialingCode }} {{ contact }}
                </ng-container>
                <ng-container *ngIf="userContext?.contactType === 'email'">
                  {{ contact }}
                </ng-container>
              </span>
            </div>
            <div class="edit-action" (click)="goBack()">
              <ng-container *ngIf="userContext?.contactType === 'phone'">
                Edit Number?
              </ng-container>
              <ng-container *ngIf="userContext?.contactType === 'email'">
                Edit Email?
              </ng-container>
            </div>
          </div>
        </div>
        <button class="verify-otp" type="submit" (click)="verifyOTP()" [class.disabled]="isVerifying">
          <span *ngIf="!isVerifying">Verify code</span>
          <span *ngIf="isVerifying">Verifying...</span>
        </button>

        <div *ngIf="verificationError" class="error-message">
          {{ verificationError }}
        </div>
        <div>
          <p *ngIf="!showResend" class="otp-resend">
            Resend verification code in <span class="span-otp-resend">{{ countdown }}s</span>
          </p>
          <p
            *ngIf="showResend"
            class="otp-resend clickable"
            (click)="resendOTP()"
          >
            Resend verification code
          </p>
        </div>
      </div>
    </ng-template>

    <!-- login.component.html -->
    <!-- <iframe src="https://tl-b.gooru.org/moe" id="myIframe" width="600" height="400"></iframe> -->
  </div>
</div>
<div *ngIf="authService?.isAutoLoginProcessing" class="ai-landing-page">
  <ai-landing-page></ai-landing-page>
</div>